import {userService} from "../../client/connection/services/UserService.js";
import {Messages} from "../Messages.js";

export function getPaymentMethodEmptySubscriptionMessage(subscription) {
    return subscription.billedUser === userService.getUser() ?
        Messages.noPaymentMethodForThisSubscription :
        Messages.noPaymentMethodForThisSubscriptionGifted;
}
